<template>
  <div :id="`${id}_cont`" class="form-group pb-2" v-if="showContent">

    <!-- Mostrar tipo de dato obligatorio (estado inicial) -->
    <template v-if="(!hasTyping || count_edit_mode == 0) && editMode">
      <div class="d-flex">
        <label v-if="title" :for="id" class="title">{{ title }}</label>
        <!-- Mostrar informacion icono  -->
        <template v-if="moreInfo" >
            <p :title="moreInfoText" class="m-0">
                <i class="ri-information-2-line"></i>
            </p>
        </template>
        <template v-if="isRequired && !errorMsgForm && editMode">
          <p class="invalid-feedback required ms-1">*</p>
        </template>
      </div>
    </template>

    <!-- Mostrar mensajes cuando exista error (Estado de envio de formulario fallido)-->
    <template v-else>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <label v-if="title" :for="id" class="title">{{ title }}</label>
          <template v-if="moreInfo" >
              <p :title="moreInfoText" class="m-0">
                  <i class="ri-information-2-line"></i>
              </p>           
          </template>
          <p class="invalid-feedback required ps-2" v-if="asterisk"> * </p>
        </div>        
        <!-- Si existe mensaje de error por validacion interna de componente -->
        <template v-if="!disableValidation && (feedback == 'invalid' || feedback == 'valid')">
          <p v-if="feedback == 'invalid'" :class="['invalid-feedback', 'required' ]">{{
            currentErrorMsg }}</p>
          <p v-else-if="feedback == 'valid'" class="valid-feedback">Completado correctamente</p>
          <p v-else>{{ errorMsgForm }}</p>
        </template>
        <!-- Si existe mensaje de error por validacion servidor -->
        <template v-else-if="errorMsgForm">
          <p class="invalid-feedback">{{ errorMsgForm }}</p>
        </template>
        <!-- Si es requerido-->
        <template v-else-if="isRequired && !errorMsgForm && showRequired">
          <p class="invalid-feedback required"> Dato obligatorio </p>
        </template>
        <!-- Si no es requerido-->
        <template v-else-if="!isRequired && showRequired && !errorMsgForm">
          <p class="invalid-feedback optional">Dato opcional</p>
        </template>
      </div>
    </template>
    <div :class="[hasIcon(icon || suffix), { 'has-suffix': suffix }]">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <input :id="id" :type="type" class="form-control " :class="getClasses(size, valid)" :name="name" :value="modelValue"
        :placeholder="placeholder" :isRequired="isRequired" :required=isRequired autocomplete="off"
        :disabled="disableSelect" :editMode="editMode" @input="startTyping1" ref="input" 
        @change="handleChange($event.target.value)"
        v-bind:min="applyPercentLimits ? min : null"
        v-bind:max="applyPercentLimits ? max : null"
        />
      <!-- @change="handleChange($event.target.value)" -->
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <!-- Unidad del valor (km/h, km, min, días) -->
      <span v-if="suffix" class="input-group-text input-suffix">{{ suffix }}</span>
    </div>
  </div>
  <!-- Loading -->
  <div :id="`${id}_cont`" class="form-group pb-2" v-else>
    <label v-if="title" class="title placeholder-glow col-3">
      <span class="placeholder col-12"></span>
    </label>
    <div class="placeholder-glow">
      <input class="form-control placeholder col-12" />
    </div>
  </div>
</template>

<script>
import validUrl from 'valid-url';
export default {
  name: "VsudInput",
  props: {
    title: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    validateTypeRut: {
      type: Boolean,
      default: false,
    },
    validateTypeEmail: {
      type: Boolean,
      default: false,
    },
    validateTypeNumber: {
      type: Boolean,
      default: false,
    },
    validateTypeNumberNotZero: {
      type: Boolean,
      default: false,
    },
    validateTypePercentage: {
      type: Boolean,
      default: false,
    },
    validateTypeURL: {
      type: Boolean,
      default: false,
    },
    validateTypeYear: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    iconDir: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    errorMsgForm: {
      type: String,
      default: '',
    },
    isRequired: Boolean,
    modelValue: {
      type: String,
      default: " "
    },
    disableValidation: {
      type: Boolean,
      default: false,
    },
    disableSelect: {
      type: Boolean,
      default: false,
    },
    showRequired: {
      type: Boolean,
      default: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    moreInfo: {
      type: Boolean,
      default: false,
    },
    moreInfoText: {
      type: String,
    },
    asterisk: {
      type: Boolean,
      default: false,
    },
    applyPercentLimits: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    // Unidad que se muestra pegada al campo, a la derecha.
    suffix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showContent: false,
      minLoadTime: 1500,
      loadStart: null,
      feedback: '', /* invalid */
      currentErrorMsg: 'Valor incorrecto o nulo',
      count_edit_mode: 0,
      hasTyping: false,
    };
  },
  mounted() {
    this.loadStart = Date.now();
    window.addEventListener("load", this.onLoad);
    setTimeout(() => {
      this.showContent = true;
    }, this.minLoadTime);

    if (this.modelValue == "") {
      this.feedback = "null";
    }
  },
  beforeUnmount() {
    window.removeEventListener("load", this.onLoad);
  },
  watch: {
    modelValue(newVal) {
      // console.log("this.$props.id", this.$props.id, "newVal: ", newVal, "hasTyping: ", this.hasTyping)
      this.count_edit_mode++;

      if (!this.hasTyping) {
        return;
      }
      // console.log("this.$props.id", this.$props.id, "newVal", newVal, "oldVal", oldVal, "disableValidation: ", this.$props.disableValidation)
      let isValid = false; // <-- bandera global de validación
      if (newVal === "" && !this.validateTypeEmail && !this.validateTypeNumber && !this.validateTypeNumberNotZero && !this.validateTypePercentage && !this.validateTypeURL && !this.validateTypeYear && !this.validateTypeRut && this.isRequired) {
        this.feedback = "invalid";
        this.currentErrorMsg = 'Valor incorrecto o nulo.';
      } else if (this.validateTypeRut && !this.validateRut(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = 'Rut incorrecto, ingrese uno válido.';
      } else if (this.validateTypeEmail && !this.validateEmail(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = 'Email incorrecto, ingrese uno válido.';
      } else if (this.validateTypeNumber && !this.validateNumber(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = 'Valor incorrecto, ingrese un número válido.';
      } else if (this.validateTypeNumberNotZero && !this.validateNumberNotZero(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = 'Valor incorrecto, ingrese un número válido mayor que cero.';
      } else if (this.validateTypePercentage && !this.validatePercentage(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = 'Porcentaje incorrecto, ingrese uno válido (Ejemplo: 50).';
      } else if (this.validateTypeURL && !this.validateURL(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = "URL incorrecta, ingrese una URL válida (Ejemplo. https://www.example.com)";
      } else if (this.validateTypeYear && !this.validateYear(newVal)) {
        this.feedback = "invalid";
        this.currentErrorMsg = "Año incorrecto, ingrese un año válido";
      } else {
        if (newVal != "") {
          this.feedback = "valid";
          this.$emit('update:modelValue',newVal);
          isValid = true;
        }
      }
      // console.log("currentErrorMsg: ", this.currentErrorMsg, "feedback ", this.feedback, "disableValidation: ", this.$props.disableValidation)
      this.$emit("feedback", this.feedback);
      this.$emit("validation", isValid); //emite siempre si es válido o no
      // if (this.feedback ==  "invalid"){
      //   this.$emit('update:modelValue','');
      // }
    },
  },
  methods: {
    validateNumber(value) {
      return !isNaN(Number(value)) && Number(value) <= 2147483647;
    },
    validateNumberNotZero(value) {
      return !isNaN(Number(value)) && Number(value) > 0 && Number(value) <= 2147483647;
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    validateRut(rut) { //Se valida que rut exista (fórmula matemática)
      let cleanRut = rut.replace(/\./g, "").replace(/-/g, "").toUpperCase();

      if (!/^\d{7,8}[0-9K]$/i.test(cleanRut)) {
        return false;
      }

      const cuerpo = cleanRut.slice(0, -1);
      let dv = cleanRut.slice(-1).toUpperCase();

      let suma = 0;
      let multiplicador = 2;

      for (let i = cuerpo.length - 1; i >= 0; i--) {
        suma += multiplicador * parseInt(cuerpo[i]);
        multiplicador = multiplicador < 7 ? multiplicador + 1 : 2;
      }

      const dvEsperado = 11 - (suma % 11);
      let dvFinal = dvEsperado === 11 ? "0" : dvEsperado === 10 ? "K" : String(dvEsperado);

      return dvFinal === dv;
    },
    validatePercentage(percentage) {
      const percentageValue = parseInt(percentage);
      return percentageValue && percentageValue >= 0 && percentageValue <= 100;
    },
    validateURL(url) {
      if (validUrl.isWebUri(url)) {
        return true;
      }
      return false;
    },
    getClasses: (size, valid) => {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      isValidValue = valid ? `${valid}` : "invalid";

      return `${sizeValue} ${isValidValue}`;
    },
    validateYear(year) {
      const currentYear = new Date().getFullYear();
      const yearValue = parseInt(year, 10);
      if (isNaN(yearValue) || yearValue < 1900 || yearValue > currentYear + 5) {
        return false;
      }
      return true;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),
    onLoad() {
      const loadTime = Date.now() - this.loadStart;
      if (loadTime >= this.minLoadTime) {
        this.showContent = true;
      } else {
        setTimeout(() => {
          this.showContent = true;
        }, this.minLoadTime - loadTime);
      }
    },
    // handleChange(newValue) {
    //   console.log("asdasda: ", newValue)
    //   this.$emit('update:modelValue', newValue);
    //   /* this.$emit('update:editMode', false); */
    // },
    handleChange(newValue) {
      this.$emit('update:modelValue', newValue);
      this.$nextTick(() => {
          if (newValue === "") {
              this.feedback = "invalid";
          } else if (newValue != "" && this.feedback == "invalid"){
            this.feedback = "invalid";
          }else {
            this.feedback = "valid";
          }
          this.$emit('feedback', this.feedback);
      });
    },
    startTyping1() {
      const newValue = this.$refs.input.value
      // console.log("startTyping1: ", this.$refs.input.value)
      // console.log("event: ", event)
      // console.log("modelValue: ", this.modelValue)
      this.$emit('update:modelValue', newValue);
      if (this.hasTyping) return;
      this.hasTyping = true;
    },
  },
};
</script>

<style scoped>
.ri-information-2-line{
  color: var(--blue);
  position: relative;
  bottom: 3px;
  padding-left: 0.3rem;
  cursor: pointer;
}
input {
  border: 1px solid var(--light-gray);
  border-radius: 12px;
}

.input-group .form-control+.input-group-text {
  border-right: 0px;
}

/* El sitio posiciona .input-group-text en absoluto sobre el campo (para los
   íconos a la izquierda) y le da 35px de margen a todo .form-control. La unidad
   va a la derecha y en el flujo normal. */
.input-group.has-suffix .form-control {
  padding-left: 0.75rem !important;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .form-control + .input-group-text.input-suffix {
  position: static;
  z-index: auto;
  height: auto;
  margin-left: 0;
  border: 1px solid var(--light-gray);
  border-left: 0;
  border-radius: 0 12px 12px 0;
  background-color: var(--background-gray);
  color: var(--dark-gray);
  font-size: 0.85rem;
  padding: 0 0.9rem;
}

.input-group .form-control {
  padding-left: 35px !important;
}

span.input-group-text {
  margin: 0 2px !important;
}

.title {
  color: var(--black);
  font-size: 0.9rem;
  font-weight: 500;
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus,
.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  box-shadow: none;
}

.optional {
  color: var(--gray-text);
}
</style>

<style>
.form-group.disabled .form-control.form-control-default.invalid{
  background-color: #DFE6EC !important;
  cursor: auto;
}
.form-group.disabled .form-control.form-control-default.invalid:hover{
  border: 1px solid var(--light-gray) !important;
}
</style>